<template>
  <div>
    <chat-container
      v-if="showChatContainer"
      :key="$route.fullPath"
      :edit-save-uri="editSaveUri"
      :chat-notifications="chatNotifications"
      @update-top-navigation="updateTopNavigation"
    />

    <div
      class="tw-sticky tw-top-[--mobile-header-height] xl:-tw-top-[--main-content-padding-top] tw-bg-white tw-z-[2]"
    >
      <header-patient />
    </div>

    <CdrFlagBanner
      v-for="(flag, index) in pendingCdrFlags"
      :key="index"
      v-bind="flag"
    />

    <router-view class="tw-pt-8" :data-patient="dataPatient" />
  </div>
</template>

<script>
import CdrFlagBanner from "../ClinicalDataRemoval/CdrFlagBanner.vue";
import { cdrPatientRefreshSignal } from "../ClinicalDataRemoval/cdr-patient-refresh";
import { practitionerHttpService } from "../../app/practitioner-portal/store/practitioner-http-service";
import HeaderPatient from "./Header.vue";
import ChatContainer from "../Examinations/AddOns/Chat/ChatContainer.vue";
import PatientOverview from "./PatientOverview.vue";
import PatientImageCompare from "./PatientImageCompare.vue";
import RelatedExaminations from "./RelatedExaminations.vue";

export default {
  components: {
    CdrFlagBanner,
    HeaderPatient,
    ChatContainer,
    PatientOverview,
    PatientImageCompare,
    RelatedExaminations,
  },
  props: {
    dataPatient: {
      type: Object,
    },
  },
  data: function () {
    return {
      chatNotifications: null,
      pendingCdrFlags: [],
    };
  },
  computed: {
    showChatContainer: function () {
      return this.$store.state.showPatientChatContainer;
    },
    editSaveUri: function () {
      return `/api/internal/${this.$route.params.id}/patient-channels`;
    },
    cdrPatientRefreshSignal: function () {
      return cdrPatientRefreshSignal.value;
    },
  },
  watch: {
    "dataPatient.pendingCdrFlags": {
      handler(val) {
        this.pendingCdrFlags = val ?? [];
      },
      immediate: true,
    },
    cdrPatientRefreshSignal() {
      this.fetchPendingCdrFlags();
    },
  },
  created() {
    localStorage.setItem("last_visited_patient_id", this.$route.params.id);
  },
  methods: {
    updateTopNavigation: function (notifications) {
      this.chatNotifications = notifications;
      this.$emit("updateTopNavigation");
    },
    fetchPendingCdrFlags: async function () {
      const response = await practitionerHttpService.get(
        "/api/internal/patients/" + this.$route.params.id,
      );
      this.pendingCdrFlags = response.data.pendingCdrFlags ?? [];
    },
  },
};
</script>
